import { render, staticRenderFns } from "./twoFactor.vue?vue&type=template&id=bc240c0a&scoped=true&"
import script from "./twoFactor.vue?vue&type=script&lang=js&"
export * from "./twoFactor.vue?vue&type=script&lang=js&"
import style0 from "./twoFactor.vue?vue&type=style&index=0&id=bc240c0a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc240c0a",
  null
  
)

export default component.exports